<template>
  <div class="page rd">
    <Header />

    <section class="hero">
      <div class="hero-overlay">
        <h1>解决方案</h1>
        <div class="tabs">
          <div
            class="tab-item"
            :class="{ active: type === 'guangfu' }"
            @click="typeChange('guangfu') "
          >
            <div class="tag"></div>
            光伏新能源
          </div>
          <div
            class="tab-item"
            :class="{ active: type === 'bandaoti' }"
            @click="typeChange('bandaoti')"
          >
            <div class="tag"></div>
            泛半导体
          </div>
        </div>
      </div>
    </section>

    <div class="section navigation">
      <div class="section-container">首页 > 解决方案 > {{ lastStep }}</div>
    </div>

    <section class="section news">
      <div class="section-container">
        <div class="list">
          <div
            class="list_item"
            v-for="(item, index) in solutionsList"
            :key="index"
            @click="goToSolutionDetail(item.id)"
          >
            <div class="title">{{ item.title }}</div>
            <div class="desc text-ellipsis-three">
              {{ item.summary }}
            </div>
            <div class="learn-more-btn">了解更多</div>
          </div>
        </div>
      </div>
    </section>
    <el-pagination 
      v-if="total"
      layout="prev, pager, next" 
      :total="total"
      :current-page="pageIndex"
      @current-change="(val) => { pageIndex = val; getSoluctionList() }"
    >
    </el-pagination>

    <!-- 联系我们 -->
    <contactModule />
    <Footer />
  </div>
</template>

<script>
import contactModule from "../components/contactModule.vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

import NumberCounter from "../components/NumberCounter.vue";
import HorizontalScroll from "../components/HorizontalScroll.vue";
import { SolutionAPI } from "../api/api";
export default {
  name: "Solutions",
  components: {
    Header,
    Footer,
    NumberCounter,
    HorizontalScroll,
    contactModule,
  },
  computed: {
    lastStep() {
      let mapObj = {
        guangfu: "光伏新能源",
        bandaoti: "泛半导体",
      };
      return mapObj[this.type];
    },
  },
  created() {
    console.log(66666, this.$route.query);
    // this.type = this.$route.query.type || "guangfu";

    // this.getSoluctionList()
  },
  activated() {
    this.type = this.$route.query.type || "guangfu";
    this.getSoluctionList()
  },
  data() {
    return {
      type: "guangfu",
      total: 0,
      solutionsList: [],
      pageIndex: 1,
      pageSize: 6,
    };
  },

  methods: {
    typeChange(type){
      this.type = type
      this.getSoluctionList()
    },
    getSoluctionList() {
      let mapObj = {
        guangfu: 1,
        bandaoti: 2,
      };
      SolutionAPI.getSolutionList({
        current: this.pageIndex,
        size: this.pageSize,
        categoryId: mapObj[this.type], // 1 太阳能 2 泛半导体
      }).then(res => {
        console.log('解决方案列表',res);
        this.solutionsList = res.records
        this.total = res.total
      })
    },
    goToSolutionDetail(id) {
      this.$router.push(`/solutions/${id}`);
    },
  },
};
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .section {
    padding-bottom: 100px;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }
  }

  .hero {
    position: relative;
    height: 580px;
    background: url("../static/soluction/head_bg.png") center/cover no-repeat;

    .hero-overlay {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      overflow: hidden;

      h1 {
        margin-top: 275px;
        font-size: 48px;
        color: #ffffff;
      }

      .tabs {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 40px !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 50px;
  }

  .news {
    padding-bottom: 0 !important ;
    .list {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      padding: 20px;
      margin: 0 auto;

      .list_item {
        cursor: pointer;
        padding: 50px;
        background: #f9fafc;
        border-radius: 8px;
        line-height: 1;
        flex: 0 0 calc(50% - 10px);

        .title {
          margin-bottom: 34px;
          font-weight: 600;
          font-size: 28px;
          color: #000000;
        }

        .desc {
          margin-bottom: 62px;
          font-size: 14px;
          color: #888888;
        }

        .learn-more-btn {
          display: inline-flex;
          align-items: center;
          line-height: 1;
          padding: 9px 24px;
          font-size: 16px;
          background: #ecf3fd;
          border-radius: 50px;
          color: #888;
        }
      }

      .list_item:hover {
        background: #ecf3fd;
        .learn-more-btn {
          background: #0248ff;
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 72px 0;

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
      width: 48px;
      height: 48px;
      background: #f8f8f8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #888;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      color: #0248ff;
    }

    ::v-deep .el-pager {
      margin: 0 32px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
    }

    ::v-deep .btn-prev:hover,
    ::v-deep .btn-next:hover,
    ::v-deep .el-pager li:not(.disabled):hover {
      background: #ecf3fd;
      color: #323232;
    }

    ::v-deep .el-pager li.active {
      background: #ecf3fd;
      color: #323232;
    }
  }

  .text-ellipsis-three {
    line-height: 1.5;
    height: 4.5em;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}
// mobile
@media (max-width: 750px) {
  .section {
    padding-bottom: 50px;

    .section-container {
      padding: 0 24px;
    }
  }

  .hero {
    position: relative;
    height: 229px;
    background: url("../static/soluction/head_bg_mobile.png");
    background-size: 100% 100%;

    .hero-overlay {
      padding-top: 55px;

      h1 {
        line-height: 174px;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
      }

      .tabs {
        position: absolute;
        bottom: 0;
        width: calc(100% - 48px);
        display: flex;
        margin: 0 24px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 31px;
          line-height: 31px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 12px;
          color: #000000;
          background: #f9fafc;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 25px;
  }

  .news {
    padding-bottom: 0 !important ;
    .list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin: 0 auto;

      .list_item {
        cursor: pointer;
        padding: 25px;
        background: #f9fafc;
        border-radius: 8px;
        line-height: 1;

        .title {
          margin-bottom: 17px;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }

        .desc {
          margin-bottom: 31px;
          font-size: 12px;
          color: #888888;
        }

        .learn-more-btn {
          display: inline-flex;
          align-items: center;
          line-height: 1;
          padding: 4px 12px;
          font-size: 12px;
          background: #ecf3fd;
          border-radius: 50px;
          color: #888;
        }
      }
    }
  }

  .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px 0;
    transform: scale(0.6);

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
      width: 48px;
      height: 48px;
      background: #f8f8f8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #888;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      color: #0248ff;
    }

    ::v-deep .el-pager {
      margin: 0 16px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
    }
    ::v-deep .el-pager li.active {
      background: #ecf3fd;
      color: #323232;
    }
  }

  .text-ellipsis-three {
    line-height: 1.5;
    height: 4.5em;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}
</style>
